export const GoogleMapsDistanceMatrixModeOption = {
    Driving: 1,
    Bicycling: 3,
};

export function getModeOptionString(mode) {
    switch (mode) {
        case GoogleMapsDistanceMatrixModeOption.Driving:
            return 'googleMapsDistanceMatrixModeOptionDriving';
        case GoogleMapsDistanceMatrixModeOption.Bicycling:
            return 'googleMapsDistanceMatrixModeOptionBicycling';
        default:
            return 'unknown'
    }
}
